// src/components/WinnersCount/WinnersCount.jsx

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updatePromoFields } from "../../../store/slices/promoFormSlice";
import { message } from "antd";

export default function WinnersCount({ create }) {
    const dispatch = useDispatch();
    const participantsCount = useSelector((state) => state.promoForm.participantsCount);
    const prizePlacesCount = useSelector((state) => state.promoForm.prizePlacesCount);
    const categoryName = useSelector((state) => state.promoForm.category.category_name);
    const positions = useSelector((state) => state.positions.positions);

    const selectedPosition = positions.find((pos) => pos.name === categoryName);
    const minParticipants = selectedPosition ? Number(selectedPosition.minParticipantsCount) : 0;
    const minPrizePlaces = selectedPosition ? Number(selectedPosition.minPrizePlacesCount) : 0;

    const [rawParticipants, setRawParticipants] = useState(participantsCount);
    const [rawWinners, setRawWinners] = useState(prizePlacesCount);

    useEffect(() => {
        if (create && selectedPosition) {
            dispatch(
                updatePromoFields({
                    participantsCount: minParticipants,
                    prizePlacesCount: minPrizePlaces,
                })
            );
            setRawParticipants(minParticipants);
            setRawWinners(minPrizePlaces);
        }
    }, [categoryName, create, dispatch, minParticipants, minPrizePlaces]);

    const handleParticipantsChange = (e) => {
        setRawParticipants(e.target.value);
    };

    const handleParticipantsBlur = () => {
        let numeric = parseInt(rawParticipants, 10);
        if (isNaN(numeric) || numeric < minParticipants) {
            numeric = minParticipants;
            message.info(`Минимальное число участников для "${categoryName}" — ${minParticipants}.`);
        }
        let updatedWinners = prizePlacesCount;
        if (updatedWinners > numeric) {
            updatedWinners = numeric;
        }
        if (updatedWinners < minPrizePlaces) {
            updatedWinners = minPrizePlaces;
            message.info(`Минимум победителей для "${categoryName}" — ${minPrizePlaces}.`);
        }
        dispatch(
            updatePromoFields({
                participantsCount: numeric,
                prizePlacesCount: updatedWinners,
            })
        );
        setRawParticipants(numeric);
        setRawWinners(updatedWinners);
    };

    const handleWinnersChange = (e) => {
        setRawWinners(e.target.value);
    };

    const handleWinnersBlur = () => {
        let numeric = parseInt(rawWinners, 10);
        if (isNaN(numeric) || numeric < minPrizePlaces) {
            numeric = minPrizePlaces;
            message.info(`Минимум победителей для "${categoryName}" — ${minPrizePlaces}.`);
        }
        if (numeric > participantsCount) {
            numeric = participantsCount;
            message.info("Количество победителей не может превышать участников.");
        }
        dispatch(updatePromoFields({ prizePlacesCount: numeric }));
        setRawWinners(numeric);
    };

    const nonWinners = Math.max(participantsCount - prizePlacesCount, 0);
    const getPercent = (v) =>
        participantsCount ? Math.round((v / participantsCount) * 100) : 0;

    return (
        <div className="flex flex-row justify-center gap-6 text-white text-center font-medium">
            {/* Participants */}
            <div className="flex flex-col items-center w-28">
                <span className="text-sm mb-1">participants</span>
                <input
                    value={rawParticipants}
                    onChange={handleParticipantsChange}
                    onBlur={handleParticipantsBlur}
                    className="bg-[#1c1c1c] border border-[#444] rounded-md text-center text-lg px-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
                <span className="text-xs mt-1 text-blue-400">
          {getPercent(participantsCount)}%
        </span>
            </div>

            {/* Winners */}
            <div className="flex flex-col items-center w-28">
                <span className="text-sm mb-1">winners</span>
                <input
                    value={rawWinners}
                    onChange={handleWinnersChange}
                    onBlur={handleWinnersBlur}
                    className={`bg-[#1c1c1c] border ${
                        prizePlacesCount > participantsCount || prizePlacesCount < minPrizePlaces
                            ? "border-red-500"
                            : "border-yellow-400"
                    } rounded-md text-center text-lg px-2 w-full focus:outline-none ${
                        prizePlacesCount > participantsCount || prizePlacesCount < minPrizePlaces
                            ? "focus:ring-red-500"
                            : "focus:ring-yellow-400"
                    }`}
                />
                <span
                    className={`text-xs mt-1 ${
                        prizePlacesCount > participantsCount || prizePlacesCount < minPrizePlaces
                            ? "text-red-400"
                            : "text-yellow-400"
                    }`}
                >
          {getPercent(prizePlacesCount)}%
        </span>
            </div>

            {/* Non-winners */}
            <div className="flex flex-col items-center w-[120px]">
                <span className="text-sm mb-1">non-winner</span>
                <input
                    value={nonWinners}
                    disabled
                    className="bg-[#1c1c1c] border border-[#444] rounded-md text-center text-lg px-2 w-full text-gray-500"
                />
                <span className="text-xs mt-1 text-gray-400">
          {getPercent(nonWinners)}%
        </span>
            </div>
        </div>
    );
}
